import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function getAllThreadsFailure(draft: Draft<IInterventionData>) {
  draft.getAllThreads.config.isLoading = false;
  draft.getAllThreads.config.errorMessage = 'errorOnLoadMessages';
}

export default getAllThreadsFailure;
